import React from 'react';
import PropTypes from 'prop-types';

// atoms
import Subtitle from '../../atoms/subtitle';
import Button from '../../atoms/button';
import Text from '../../atoms/text';

// style
import './style.scss';

const UpdateUserErrorOrganism = ({ signOut, userCpf }) => {
  return (
    <>
      <Subtitle>Ops!</Subtitle>
      <Text>{`O CPF ${userCpf} já possui uma conta vinculada.`}</Text>
      <Button
        action
        onClick={() => {
          window.isRecoveringAccount = true;
          signOut();
        }}
      >
        Recuperar conta
      </Button>
      <Button action onClick={signOut}>
        Trocar de usuário
      </Button>
    </>
  );
};

UpdateUserErrorOrganism.propTypes = {
  signOut: PropTypes.func.isRequired,
  userCpf: PropTypes.string.isRequired
};

export default UpdateUserErrorOrganism;
